import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Facebook, Instagram, Linkedin, ArrowUpRight } from 'lucide-react';
import { COMPANY, SOLUTIONS } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-[#0d3a60] text-white relative overflow-hidden on-dark">
      <img src="/logos/logo-white.png" alt="" aria-hidden="true" className="absolute -right-20 -bottom-32 w-[420px] opacity-[0.06] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-20 pb-10 relative">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img src="/logos/logo-white.png" alt="SER" className="h-16 w-auto mb-5" />
            <p className="text-sm text-white/70 leading-relaxed">Installateur de panneaux solaires et pompes à chaleur en Suisse romande. Une énergie plus propre, plus libre, plus locale.</p>
            <div className="flex gap-3 mt-6">
              <a href={COMPANY.socials.facebook} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/20 hover:bg-[#80b23f] hover:border-[#80b23f] flex items-center justify-center transition-colors"><Facebook className="w-4 h-4" /></a>
              <a href={COMPANY.socials.instagram} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/20 hover:bg-[#80b23f] hover:border-[#80b23f] flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>
              <a href={COMPANY.socials.linkedin} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/20 hover:bg-[#80b23f] hover:border-[#80b23f] flex items-center justify-center transition-colors"><Linkedin className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-widest text-[#80b23f] font-semibold mb-5">Nos solutions</h4>
            <ul className="space-y-3 text-sm text-white/80">
              {SOLUTIONS.slice(0,4).map(s => (
                <li key={s.slug}><Link to={`/solutions/${s.slug}`} className="hover:text-white transition-colors">{s.title}</Link></li>
              ))}
              <li><Link to="/solutions" className="hover:text-white transition-colors inline-flex items-center gap-1">Toutes les solutions <ArrowUpRight className="w-3 h-3" /></Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-widest text-[#80b23f] font-semibold mb-5">Navigation</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li><Link to="/" className="hover:text-white transition-colors">Accueil</Link></li>
              <li><Link to="/a-propos" className="hover:text-white transition-colors">À propos</Link></li>
              <li><Link to="/solutions" className="hover:text-white transition-colors">Nos solutions</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Demander un devis</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-widest text-[#80b23f] font-semibold mb-5">Contact</h4>
            <ul className="space-y-4 text-sm text-white/80">
              <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#80b23f]" /><span>{COMPANY.address}</span></li>
              <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 shrink-0 text-[#80b23f]" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white whitespace-nowrap text-[13px]">{COMPANY.email}</a></li>
              <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0 text-[#80b23f]" /><a href="tel:+41225187155" className="hover:text-white">022 518 71 55</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center text-xs text-white/60">
          <div>© {new Date().getFullYear()} Suisse Energies Renouvelables. Tous droits réservés.</div>
          <div className="flex flex-wrap gap-5">
            <a href={COMPANY.legal.mentionsLegales} target="_blank" rel="noreferrer noopener" className="hover:text-white">Mentions légales</a>
            <a href={COMPANY.legal.politique} target="_blank" rel="noreferrer noopener" className="hover:text-white">Politique de confidentialité</a>
            <a href={COMPANY.legal.cgv} target="_blank" rel="noreferrer noopener" className="hover:text-white">CGV</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
